export default function SubIntro({
  mainTitle,
  subTitle,
  menuItems = [],
  activeCategory,
  onCategoryChange,
  isTabMode = false,
}) {
  const handleMenuClick = (item, index) => {
    if (isTabMode) {
      if (onCategoryChange) {
        onCategoryChange(item.category || item.title, index);
      }
    } else {
      if (item.link) {
        window.location.href = item.link;
      }
    }
  };

  return (
    <>
      <div className="sub_intro flex-center pt-5">
        <div className="col-flex txt-center">
          <p className="prt-bold fs-60 fc-black1">{mainTitle}</p>

          <div className="flex-center">
            <p className="prt-light fs-22 fc-60 sub_intro_subtitle  m-m-auto m-w-80">
              {subTitle}
            </p>
          </div>

          <div className="row-flex gap-50 justify-center m-flex-wrap m-w-80 m-m-auto ">
            {menuItems.map((item, index) => {
              const isActive = isTabMode
                ? activeCategory === (item.category || item.title)
                : item.active;

              return isTabMode ? (
                // 탭 모드
                <button
                  key={index}
                  onClick={() => handleMenuClick(item, index)}
                  className={`prt-bold fs-24 sub_menu_item pt-4 pb-1 ${
                    isActive ? 'active' : ''
                  }`}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  {item.title}
                </button>
              ) : (
                // 기본 모드
                <a
                  key={index}
                  href={item.link}
                  className={`prt-bold fs-24 sub_menu_item pt-4 pb-1 w-26 
                    ${isActive ? 'active' : ''}`}
                >
                  {item.title}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
